export default "__VITE_ASSET__DpB23dB0__"